<script lang="ts">
	import UnitManagementV2 from 'src/components/Settings/HomeManagement/UnitManagementV2.svelte';
	import SharedHomesToMeListV2 from 'src/components/Settings/HomeManagement/SharedHomesToMeListV2.svelte';
	import PendingHomesListV2 from 'src/components/Settings/HomeManagement/PendingHomesListV2.svelte';
</script>

<UnitManagementV2 />
<SharedHomesToMeListV2 />
<PendingHomesListV2 />
